module.exports = __webpack_public_path__ + "img/daren_3.340343e8.png";